import { HttpErrorResponse } from '@angular/common/http';
import { ErrorHandler, Inject, Injectable, Injector } from '@angular/core';
import { Router } from '@angular/router';
import { Subject } from 'rxjs';
import { LoadingService } from './loading.service';
import { APP_CONFIG, AppConfig } from '../../app.config';

@Injectable({
    providedIn: 'root',
})
export class ErrorService implements ErrorHandler {
    errorThrown = new Subject();

    constructor(
        private injector: Injector,
        private loader: LoadingService,
        // private authService: AuthService,
        @Inject(APP_CONFIG) private config: AppConfig
    ) {}

    handleError(error: HttpErrorResponse) {
        if (this.config.useMock) {
            return;
        }
        const router = this.injector.get(Router);
        this.loader.hideLoading();
        this.errorThrown.next(error.message || 'An unknown error occurred');

        switch (error.status) {
            case 0: //UNKNOWN
            case 400: //BAD REQUEST
            case 404: //NOT FOUND
            case 500: //INTERNAL SERVER ERROR
            case 503: //SERVICE UNAVAILABLE
            case 504: //TIMEOUT
                router.navigate(['/error-system-failure']);
                break;
            case 401: //UNAUTHORIZED
            case 403: //FORBIDDEN
                break;
        }
    }
}
